import { createTheme as createTheme$1 } from "@mui/material/styles";
import { palette } from "../colors/palette.js";
import { shadows } from "../../themes/shadows/shadows.js";
import { typography, MuiTypography } from "../../themes/typography/typography.js";
import "@mui/material";
import "../../themes/typography/utils/defaultVariantMapping/defaultVariantMapping.js";
import "../../themes/typography/utils/typographyVariants/typographyVariants.js";
const createTheme = (options = {}) => createTheme$1({
  variant: "internal",
  palette,
  typography,
  shadows,
  ...options,
  components: {
    MuiTypography,
    ...options.components ?? {}
  }
});
export {
  createTheme
};
